/** Estimate quote total from current pricing row and quote form values (matches backend logic). */
export function calculateQuoteEstimate(pricing, quoteValues = {}) {
  if (!pricing) return 0;

  const dieselQty = parseFloat(quoteValues.diesel_quantity) || 0;
  const defQty = parseFloat(quoteValues.def_quantity) || 0;
  const dyedQty = parseFloat(quoteValues.dyed_quantity) || 0;
  const deliveryFee = parseFloat(quoteValues.delivery_fee) || 0;

  const dieselPrice = parseFloat(pricing.diesel_price_per_liter) || 0;
  const defPrice = parseFloat(pricing.def_price_per_liter) || 0;
  const dyedPrice = parseFloat(pricing.dyed_price_per_liter) || 0;

  const dieselTax = parseFloat(pricing.diesel_sales_tax) || 0;
  const defTax = parseFloat(pricing.def_sales_tax) || 0;
  const dyedTax = parseFloat(pricing.dyed_sales_tax) || 0;

  const dieselCost = dieselQty * dieselPrice;
  const defCost = defQty * defPrice;
  const dyedCost = dyedQty * dyedPrice;

  const dieselTaxAmount = dieselCost * dieselTax;
  const defTaxAmount = defCost * defTax;
  const dyedTaxAmount = dyedCost * dyedTax;

  return (
    dieselCost +
    dieselTaxAmount +
    defCost +
    defTaxAmount +
    dyedCost +
    dyedTaxAmount +
    deliveryFee
  );
}
